import { ReactElement, useEffect, useState } from 'react';
import { Input } from '../../../../Input';
import { Select } from '../../../../Select';
import { Button } from '../../../../Button';
import Modal from 'react-modal';
import { useRouteLoaderData } from 'react-router-dom';
import './functionaryForm.css';
import { SaveIcon } from '../../../../icons/SaveIcon';
import { dependentsSchema } from '../../../data/schema GDF/dependentsSchema';
import {
  changeCivilStatus,
  changeGender,
  changeParentage,
  changeParentageGDF,
  changeUF,
} from '../../../../../utils/ChangeArrays';
import { z } from 'zod';
import {
  useDependentAddDataStore,
  useDependentIdStore,
  useDependentOpenModalDataStore,
} from '../../../../../stores/useDependentStore';
import { useVidaCountStore } from '../../../../../stores/useQuantidadeVidas';
import { useBoostedPlanDataStore } from '../../../../../stores/useBoostedPlanDataStore';
import { useIncludeFunctionaryForm } from '../../../../../contexts/IncludeFunctionaryFormProvider';
import { useFunctionaryExistsStore } from '../../../../../stores/useFunctionaryStore';

function validateDependent(obj: any): boolean {
  try {
    dependentsSchema.parse(obj);
    return true;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return false;
    }
    return false;
  }
}

Modal.setAppElement('#root');

export function DependentForm(): ReactElement {
  const { register, handleSubmit, onSubmit, errors, watch, setValue } =
    useIncludeFunctionaryForm();
  const [initialPlanData, setinicialPlanData] = useState<any>([]);
  const dados: any = useRouteLoaderData('Empresa-token');
  const setAddDependent = useDependentAddDataStore(x => x.setdependentAddData);
  const boostedPlanData = useBoostedPlanDataStore(x => x.data);
  const DependentOpenModal = useDependentOpenModalDataStore(x => x.data);
  const setDependentOpenModal = useDependentOpenModalDataStore(
    x => x.setdependentOpenModalData,
  );
  const setCountVida = useVidaCountStore(x => x.setVidaCount);
  const [dependentPlanData, setDependentPlanData]: any = useState();
  const funcionarioExistente = useFunctionaryExistsStore(x => x.existe);

  useEffect(() => {
    fetchPlanData();
  }, []);

  const fetchPlanData = async () => {
    const urlPlan = process.env.REACT_APP_OG_GET_PLAN_DETAILS_COMPANY;
    const Plan = await fetch(`${urlPlan}${dados.TokenVd}`);

    const retorno = await Plan.json();
    console.log('retorno: ', retorno);
    setinicialPlanData(retorno);
  };

  const getFieldPath = (campo: string) => {
    return `${
      funcionarioExistente ? 'newDependents' : 'user.funcionario.dependentes'
    }.${Id}.${campo}`;
  };

  const getFieldError = (campo: string) =>
    errors?.[
      funcionarioExistente ? 'newDependents' : 'user?.funcionario?.dependentes'
    ]?.[Id]?.[campo]?.message;

  /* const Planos = [
    {
      Id: 994,
      Nome: 'OdontoClinico - apenas R$ 22,90 por Dependente',
      vl: '22,90',
    },
    {
      Id: 998,
      Nome: 'OdontoDoc - apenas R$ 32,90 por Dependente',
      vl: '32,90',
    },
    {
      Id: 999,
      Nome: 'OdontoProtese - apenas R$ 89,90 por Dependente',
      vl: '89,90',
    },
    {
      Id: 1000,
      Nome: 'OdontoOrto - apenas R$ 110,00 por Dependente',
      vl: '110,00',
    },
  ]; */

  const carregamentos = async () => {
    changeGender(initialPlanData.listaSexos);
    changeCivilStatus(initialPlanData.listaEstadosCivil);
    changeParentage(initialPlanData.listaParentescos);
  };
  const [data, setData] = useState(initialPlanData);
  useEffect(() => {
    carregamentos();
    setData(initialPlanData);
  }, [initialPlanData]);
  const dependentes = watch(`user.funcionario.dependentes`) || [];
  const id = useDependentIdStore(state => state.id);
  const setId = useDependentIdStore(state => state.setId);

  const Id = id || 0;
  const dependenteData = dependentes[Id];

  const saveDependent = () => {
    validateDependent(dependenteData);
    setAddDependent(true);
    alert('Dependente salvo com sucesso!');
    const quantidadeDependentes = dependentes?.length || 0;
    if (dependentes && dependentes[0].cpf) {
      setCountVida(quantidadeDependentes + 1);
    }
    setDependentOpenModal(false);
  };
  const openModal = () => {
    setDependentOpenModal(true);
    if (dependentes && dependentes[0].cpf == '') {
      setId(0);
    } else {
      setId(dependentes.length);
    }
  };

  const closeModal = () => {
    setDependentOpenModal(false);
  };
  useEffect(() => {
    setDependentOpenModal(false);
  }, []);

  useEffect(() => {
    const quantidadeDependentes = dependentes?.length || 0;
    if (dependentes && dependentes[0] && dependentes[0].cpf) {
      setCountVida(quantidadeDependentes + 1);
    } else {
      setCountVida(1);
    }
  }, [dependentes]);

  return (
    <div>
      <div className="w-full relative flex min-[748px]:justify-end justify-center gap-6">
        <Button type="button" text="Adicionar Dependente" onClick={openModal} />
      </div>

      <Modal
        isOpen={DependentOpenModal}
        onRequestClose={closeModal}
        contentLabel="Formulário de Funcionário"
        className="modal"
        overlayClassName="modal-backdrop"
      >
        <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
          Dados do Dependente
        </h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <div className="min-[748px]:col-span-2">
              <Input
                label="Nome"
                placeholder="Nome"
                errorMessage={
                  funcionarioExistente
                    ? errors?.newDependents?.[Id]?.nome?.message
                    : errors?.user?.funcionario?.dependentes?.[Id]?.nome
                        ?.message
                }
                {...register(
                  funcionarioExistente
                    ? `newDependents.${Id}.nome`
                    : `user.funcionario.dependentes.${Id}.nome`,
                )}
              />
            </div>

            <Input
              activateMask
              mask="999.999.999-99"
              label="CPF"
              placeholder="CPF"
              errorMessage={
                funcionarioExistente
                  ? errors?.newDependents?.[Id]?.cpf?.message
                  : errors?.user?.funcionario?.dependentes?.[Id]?.cpf?.message
              }
              {...register(
                funcionarioExistente
                  ? `newDependents.${Id}.cpf`
                  : `user.funcionario.dependentes.${Id}.cpf`,
              )}
            />

            <div className="grid min-[748px]:grid-cols-3 gap-8">
              <Input
                activateMask
                mask="99/99/9999"
                label="Data de nascimento"
                placeholder="dd/mm/aaaa"
                errorMessage={
                  funcionarioExistente
                    ? errors?.newDependents?.[Id]?.dtNascimento?.message
                    : errors?.user?.funcionario?.dependentes?.[Id]?.dtNascimento
                        ?.message
                }
                {...register(
                  funcionarioExistente
                    ? `newDependents.${Id}.dtNascimento`
                    : `user.funcionario.dependentes.${Id}.dtNascimento`,
                )}
              />

              <Select
                label="Estado civil"
                placeholder="Estado civil"
                options={[]}
                optionsFull={data.listaEstadosCivil}
                errorMessage={
                  funcionarioExistente
                    ? errors?.newDependents?.[Id]?.estCivil?.message
                    : errors?.user?.funcionario?.dependentes?.[Id]?.estCivil
                        ?.message
                }
                {...register(
                  funcionarioExistente
                    ? `newDependents.${Id}.estCivil`
                    : `user.funcionario.dependentes.${Id}.estCivil`,
                )}
              />

              <Select
                label="Gênero"
                placeholder="Gênero"
                options={[]}
                optionsFull={data.listaSexos}
                errorMessage={
                  funcionarioExistente
                    ? errors?.newDependents?.[Id]?.sexo?.message
                    : errors?.user?.funcionario?.dependentes?.[Id]?.sexo
                        ?.message
                }
                {...register(
                  funcionarioExistente
                    ? `newDependents.${Id}.sexo`
                    : `user.funcionario.dependentes.${Id}.sexo`,
                )}
              />
            </div>

            <div className="grid min-[748px]:grid-cols-3 gap-8">
              <div className="min-[748px]:col-span-2">
                <Input
                  label="Nome da mãe"
                  placeholder="Nome da mãe"
                  errorMessage={
                    funcionarioExistente
                      ? errors?.newDependents?.[Id]?.motherName?.message
                      : errors?.user?.funcionario?.dependentes?.[Id]?.motherName
                          ?.message
                  }
                  {...register(
                    funcionarioExistente
                      ? `newDependents.${Id}.motherName`
                      : `user.funcionario.dependentes.${Id}.motherName`,
                  )}
                />
              </div>

              <Select
                label="Parentesco"
                placeholder="Parentesco"
                options={[]}
                optionsFull={initialPlanData.listaParentescos}
                errorMessage={
                  funcionarioExistente
                    ? errors?.newDependents?.[Id]?.parentesco?.message
                    : errors?.user?.funcionario?.dependentes?.[Id]?.parentesco
                        ?.message
                }
                {...register(
                  funcionarioExistente
                    ? `newDependents.${Id}.parentesco`
                    : `user.funcionario.dependentes.${Id}.parentesco`,
                )}
              />
            </div>
          </div>
        </form>
        <div
          style={{
            display: 'flex',
            marginTop: '25px',
            flexDirection: 'row-reverse',
          }}
        >
          <Button
            type="button"
            onClick={closeModal}
            text="Cancelar"
            style={{ background: '#CC0505' }}
          />
          <Button
            type="button"
            intent="secondary"
            Icon={SaveIcon}
            onClick={saveDependent}
            text="Salvar Dependente"
            style={{ marginRight: '20px' }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            marginTop: '25px',
            flexDirection: 'row-reverse',
          }}
        >
          <Button type="button" text="Fechar" onClick={closeModal} />
        </div>
      </Modal>
    </div>
  );
}

export default DependentForm;
